import { House, MessageSquare, LifeBuoy, Settings, Users, UsersRound, Wrench, CalendarDays, List, Route, ScrollText, Tags, Trash2, Truck, TriangleAlert, Megaphone, Send, Package, ClipboardList, MapPin, Activity, OctagonAlert, ListTodo, Mail, CircleUser, Circle, Clock } from 'lucide-react';

// Maps the `icon` names in shared/src/nav.js to Lucide icons. Named imports
// only, so the bundle carries just the icons we use. Add new ones here when a
// module adds a nav entry.
const ICONS = {
  home: House,
  inbox: MessageSquare,
  help: LifeBuoy,
  settings: Settings,
  users: Users,
  team: UsersRound,
  operations: Wrench,
  calendar: CalendarDays,
  list: List,
  route: Route,
  van: Truck,
  tags: Tags,
  audit: ScrollText,
  trash: Trash2,
  alert: TriangleAlert,
  megaphone: Megaphone,
  clock: Clock,
  send: Send,
  box: Package,
  clipboard: ClipboardList,
  pin: MapPin,
  pulse: Activity,
  defect: OctagonAlert,
  tasks: ListTodo,
  mail: Mail,
  user: CircleUser,
};

export default function NavIcon({ name, size = 24, badge = 0 }) {
  const Icon = ICONS[name] || Circle;
  const icon = <Icon size={size} strokeWidth={2} aria-hidden="true" focusable="false" />;
  if (!badge) return icon;
  return (
    <span className="nav-icon-badged">
      {icon}
      <span className="nav-badge">{badge > 99 ? '99+' : badge}<span className="sr-only"> unread</span></span>
    </span>
  );
}
